import axios from 'axios';
import ss from './Session';
import * as amplitude from '@amplitude/analytics-browser';

const randomString = (length: number) =>
  new Array(length).fill(0)
    .map((x) => String.fromCharCode(65 + Math.floor(Math.random() * 2) * 32 + Math.floor(Math.random() * 26)))
    .join("");

// eslint-disable-next-line no-template-curly-in-string
const package_version:string = (((window as any)?.package_version || "NA") === '${package_version}')?"DEV":((window as any)?.package_version || "NA");
    
export async function logBehavior (what: string, detail?: any) {

    if (!detail){
        detail = {}
    }

    if (!detail.page){
        detail.page = window.location.pathname;
    }

    if (!sessionStorage.getItem('sessionid')){
        let currentTime = Date.now()/1000;
        let sessionid = localStorage.getItem('sessionid');
        let sessionNumber = 1;
        try {
            sessionNumber = Number(localStorage.getItem('session:number') || "0") || 0;
            sessionNumber += 1;
        }catch(e){
            console.error('invalid sessionNumber', e);
        }
        if (!sessionid){
            sessionid = randomString(16);
            localStorage.setItem('sessionid', sessionid);
            localStorage.setItem('session:firstStartedAt', String(currentTime));

            await sendBehavior("sessionStart", {});
        }else {
            sessionNumber += 1;
            await sendBehavior("revisit", {
                interval: currentTime - Number(localStorage.getItem('session:lastStartedAt') || '0'),
                intervalFromStart: currentTime - Number(localStorage.getItem('session:firstStartedAt') || '0'),
                sessionNumber
            });
        }
        localStorage.setItem('session:lastStartedAt', String(currentTime));
        localStorage.setItem('session:number', String(sessionNumber));
        sessionStorage.setItem('sessionid', sessionid);
    }

    return await sendBehavior(what, detail);
}

async function sendBehavior (what: string, detail: any) {
    let sessionid = localStorage.getItem('sessionid');
    if (!detail.page){
        if ('canonicalPath' in window){
            detail.page = window.canonicalPath;
        }else{
            detail.page = window.location.pathname;
        }
    }
    
    if (['127.0.0.1', 'localhost:3000', 'mydomain.com:3000', 'localhost:3001', 'mydomain.com:3001',
        'dev.webtoon.today', 'challenge-dev.webtoon.today', 'stage.webtoon.today', 'challenge-stage.webtoon.today'
    ].indexOf(window.location.host) >= 0){
        detail.debug = true;
    }
    
    let userid = ss.getCurrentSession().userid;
    try{
        let res = await axios.post('https://challenge-api.webtoon.today/behavior', {logs:[ {what, userid, sessionid, detail, package_version} ]}, {
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            },
            withCredentials: true
        });

        await amplitude.logEvent(what, {userid, sessionid, detail});

        if (res.data && res.data.code === 200){
            
            return true;

        }else{
            return false;
        }
    }catch(e){
        return false;
    }
}

export async function logBulkBehavior (arr: {sessionid: string, userid: string, what: string, detail: any}[]) {
    
    
    let userid = ss.getCurrentSession().userid;
    let sessionid = localStorage.getItem('sessionid');

    let logs = arr.map(row => ({
        sessionid,
        userid,
        what: row.what,
        package_version,
        detail: {
            page: (window as any).canonicalPath || window.location.pathname,
            ...(row.detail),
            ...((['127.0.0.1', 'localhost:3000', 'mydomain.com:3000', 'localhost:3001', 'mydomain.com:3001',
                    'dev.webtoon.today', 'challenge-dev.webtoon.today', 'stage.webtoon.today', 'challenge-stage.webtoon.today'
                    ].indexOf(window.location.host) >= 0)
                ?{debug: true}:{})
        },
    }))
    try{
        let res = await axios.post('https://challenge-api.webtoon.today/behavior', {logs}, {
            headers: {
                Authorization: `Bearer ${ss.getCurrentSession().jwt}`
            },
            withCredentials: true
        });

        if (res.data && res.data.code === 200){
            
            return true;

        }else{
            return false;
        }
    }catch(e){
        return false;
    }
}